import { Button, Paper, Radio, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs } from '@mui/material'
import { Box } from '@mui/system'
import { useEffect, useState } from 'react'
import { Item, SuccessPopUp } from '../../../common/snippets'
import { connect } from 'react-redux'
import {
  BranchRechargesReject,
  GetBranchRechargesListAll,
  updateModal,
  BranchRechargesAccept,
  GetRechargePaymentModesListAll,
} from '../../../../store/common/common_action'

import * as mdt from '../../../../components/common/modaltypes'
import PartyVoucherPage from './PartyVoucher/PartyVoucherPage'
import { useSearchParams } from 'react-router-dom'
import RechargeHistoryTab from './RechargeHistory/RechargeHistoryTab'
import DebitCreditTab from './DebitCreditNote/DebitCreditTab'
import QRTransactionsPage from './QRTransactions/QRTransactionsPage'
import { useTranslation } from '../../../../i18n/I18nProvider'

const RechargeDebitCreditNote = (props) => {
  const {
    data: { common },
    GetBranchRechargesListAll,
    updateModal,
    BranchRechargesReject,
    BranchRechargesAccept,
    GetRechargePaymentModesListAll,
  } = props
  const { translations } = useTranslation()
  const rdcn = translations?.rechargeDebitCreditNote || {}
  const { loginData, RechargeList, showModal, modalType, RechargePaymentList } = common
  const { intCompanyID, intBranchID } = loginData
  const [selectedRadio, setSelectedRadio] = useState('recharge')
  const [rechargeData, setRechargeData] = useState()
  const [action, setAction] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [editIndex, setEditIndex] = useState()
  // useEffect(() => {
  //   const obj = {
  //     intCompanyID,
  //     intBranchID,
  //   }
  //   GetBranchRechargesListAll(obj)
  //   GetRechargePaymentModesListAll()
  //   handleSenderSect(0, 0)
  // }, [])
  const [searchParams, setSearchParams] = useSearchParams()
  const [masterNumber, setMasterNumber] = useState(Number(searchParams.get('tab'))||"")
  const [allTabs, setAllTabs] = useState([])

  const tabsList = [
    { JobID: 91, name: rdcn.rechargeHistory || 'Recharge History' },
    { JobID: 92, name: rdcn.debitCreditNote || 'Debit/Credit Note' },
    { JobID: 93, name: rdcn.partyVoucher || 'Party Voucher' },
    { JobID: 94, name: rdcn.qrTransactions || 'QR Transactions' },
  ]
  useEffect(() => {
      // if(masterNumber===""){
      //     goToTabs(2)
      // }
      const allGSPages = sessionStorage.getItem('token1');
      const allGSPagesActive = JSON.parse(allGSPages);
    
      if (masterNumber === '') {
        const newData = tabsList.filter((item) =>item)
        // item.JobID!==4? findObjctByValueFromArrayOfObject(allGSPagesActive, item.JobID, 'JobID', "IsActive") === 1 ? item : null:
        goToTabs(newData?.[0]?.JobID)
      }
    
      if (allGSPagesActive?.length > 0) {
        setAllTabs(allGSPagesActive)
      } else {
        setAllTabs([])
      }
  }, [searchParams])
  const params = {}
  for (let entry of searchParams.entries()) {
    params[entry[0]] = entry[1]
  }
  const goToTabs = (lrTab) => {
    params.tab = lrTab
    setSearchParams(params)
    setMasterNumber(lrTab)
  }

  const contentShow = (key) => {
      let MasterTab
      switch (key) {
          case 91: {
              MasterTab = <RechargeHistoryTab/>
              break
          }
          case 92: {
              MasterTab = <DebitCreditTab/>
              break
          }
          case 93: {
              MasterTab = <PartyVoucherPage />
              break
          }
          case 94: {
            MasterTab = <QRTransactionsPage />
            break
          }         
          default:
              MasterTab = ''
              break
      }
      return MasterTab
  }
  const handleChange = (type) => {
    if (type === 'branch' || type === 'party') {
      updateModal(true, mdt.branchCreditDebitNote)
    }
    setSelectedRadio(type)
  }
  return (
    // <>
    <div style={{ position: 'absolute', width: '100%' }}>
      {/* <Item sx={{ padding: '0' }} className="reports">
        <Box className="light-bg radio-wrap" sx={{ paddingLeft: '15px', paddingRight: '24px', display: 'flex' }}>
          <label htmlFor={'isCrossingRadioYes'} className="radio-label flex">
            <Radio
              id={'isCrossingRadioYes'}
              name={`isCrossingRadio`}
              size={'medium'}
              value="recharge"
              checked={selectedRadio === 'recharge'}
              onChange={(e) => {
                handleChange('recharge')
              }}
            />
            Recharge History
          </label>
          <label htmlFor={'isCrossingRadioNo'} className="radio-label flex">
            <Radio
              id={'isCrossingRadioNo'}
              name={`isCrossingRadio`}
              size={'medium'}
              value="branch"
              checked={selectedRadio === 'branch'}
              onChange={(e) => {
                handleChange('branch')
              }}
            />
            Debit/Credit Note For Branch
          </label>
          <label htmlFor={'isCrossingRadioNo'} className="radio-label flex">
            <Radio
              id={'isCrossingRadioNo'}
              name={`isCrossingRadio`}
              size={'medium'}
              value="party"
              checked={selectedRadio === 'party'}
              onChange={(e) => {
                handleChange('party')
              }}
            />
            Debit/Credit Note For Party
          </label>
        </Box>
      </Item> */}
       <>
            <Box className='brnchUsrMaster'>
                {
                    tabsList?.map((val, i) =>
                        <Button key={i} className={`brnchUsrMasterBtn ${masterNumber == val.JobID ? 'active' : ''}`} variant="outlined" onClick={() => goToTabs(val.JobID) }
                        sx={{
                            display:'inline-block'
                            // val.JobID!==4? findObjctByValueFromArrayOfObject(allTabs, val.JobID, 'JobID',"IsActive")===1
                            //     ? 'inline-block'
                            //     : 'none':'inline-block',
                          }}
                        >{val.name}</Button>
                    )
                }
            </Box>
            <Box>
                {contentShow(masterNumber)}
            </Box>
        </>
      {/* <Item
        sx={{
          width: '100%',
          margintTop: '10px',
          padding: '0px',
          //   paddingLeft: '19px',
          //  marginRight: '25px',
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={senderSectContent} onChange={handleSenderSect} aria-label="bsic tabs example">
            {senderSect.map((reqType, index) => (
              <Tab key={`sender_${index}`} label={reqType} {...a11yProps(index)} style={{ lineHeight: '2.5' }} />
            ))}
          </Tabs>
        </Box>
      </Item>
      {senderSectContent === 0 ? <RechargeBranch /> : ''}
      {senderSectContent ===1 ? <RechargeParty /> : ''}

      {showModal && mdt.branchCreditDebitNote === modalType && (
        <BranchCreditDebitNote handleChange={handleChange} selectedRadio={selectedRadio == 'branch' ? 'branch' : 'party'} />
      )} */}
    </div>
    // </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  GetBranchRechargesListAll,
  updateModal,
  BranchRechargesReject,
  BranchRechargesAccept,
  GetRechargePaymentModesListAll,
}
export default connect(mapStateToProps, mapDispatchToProps)(RechargeDebitCreditNote)
